import { NotificationActions } from '../store/actions/notificationActions';
import { NotificationType } from '../views/NotificationsManager/Notification/Notification';

export function initErrorsHandler() {
  function isUnidentifiableError(message: any, line: any, column: any, error: any, url: any) {
    return message === 'Script error.' && line === 0 && column === 0 && error == null;
  }

  if (typeof window !== 'undefined') {
    window.onerror = null;
    window.onerror = function (msg: any, url: any, line: any, column: any, err: any) {
      if (msg.startsWith('ResizeObserver loop')) return false;

      if (isUnidentifiableError(msg, line, column, err, url)) {
        // possible error from external script that we cannot identify due to CORS restrictions
        return true;
      }
      const message =
        msg + '\n\nFile: ' + url + '\n\nLine:' + line + '\n\nColumn:' + column + '\n\nStacktrace:' + (err && err.stack ? err.stack.toString() : '');

      NotificationActions.addNotification({
        type: NotificationType.CLIENT_ERROR,
        message: 'Error',
        title: '',
        details: message,
        hideCloseButton: false,
        closeTimeout: 180000,
      });

      return true;
    };
  }
}
